import React from "react";
import PropTypes from "prop-types";
import "./SponsorsSection.css"; // Ensure you create this CSS file

const SponsorsSection = ({ data }) => {
  if (!data) return null;

  return (
    <section id="sponsors" className="sponsors-section section-title mb-">
      <h2 className="text-3xl font-bold">Patrocinadores</h2>
      <div className="sponsors-grid">
        {data.map((sponsor, index) => (
          <div key={index} className="sponsor-item">
            <a href={sponsor.link} target="_blank" rel="noopener noreferrer">
              <img
                src={sponsor.image}
                alt={sponsor.name}
                className="sponsor-logo"
              />
            </a>
          </div>
        ))}
      </div>

      {/* CTA Section */}
      <div className="sponsor-cta">
        <p className="cta-text">
          Participa como <strong>PATROCINADOR</strong> y todo Polk County te
          conocerá.
        </p>
        <a
          href="https://wa.me/message/HXDFKP63WDZOL1"
          target="_blank"
          rel="noopener noreferrer"
          className="cta-button"
        >
          ¡Clickea aquí! <i className="fab fa-whatsapp"></i>
        </a>
      </div>
    </section>
  );
};

SponsorsSection.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      link: PropTypes.string,
    })
  ).isRequired,
};

export default SponsorsSection;
